import {
  Box,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
} from '@chakra-ui/react'

import { PageLayout } from '../../components/PageLayout/PageLayout'
import { roles } from '../../config/roles'
import { useAppStore } from '../../store/appStore/appStore'
import { browserTabStaticPageTitles } from '../../store/appStore/browserDocumentTitle/browserTabTitleSpec'
import { useViewWidgetState } from '../../store/appStore/view/useViewWidgetState'
import { ApiKeysEditor } from './ApiKeysEditor'
import { UserSettingsEditor } from './UserSettingsEditor'

export const SettingsPage = () => {
  const hasRoles = useAppStore(({ auth }) => auth.hasRole)

  const [{ tabIndex }, setWidgetState] = useViewWidgetState({
    widgetId: 'settings',
    state: {
      tabIndex: 0,
    },
    persist: true,
  })

  return (
    <PageLayout
      documentTitle={browserTabStaticPageTitles.settings}
      headerSlot={<Heading variant="pageTitle">Settings</Heading>}
    >
      <VStack
        alignItems="start"
        flex="1 1 0"
        spacing={4}
        width="100%"
        pt="16px"
      >
        <Box width="100%">
          <Tabs
            index={tabIndex}
            onChange={index => setWidgetState({ tabIndex: index })}
          >
            <TabList>
              <Tab>Preferences</Tab>
              {hasRoles([roles.heloInternal]) && <Tab>API Keys</Tab>}
            </TabList>

            <TabPanels>
              <TabPanel paddingTop="26px">
                <UserSettingsEditor />
              </TabPanel>
              {hasRoles([roles.heloInternal]) && (
                <TabPanel paddingTop="26px">
                  <ApiKeysEditor />
                </TabPanel>
              )}
            </TabPanels>
          </Tabs>
        </Box>
      </VStack>
    </PageLayout>
  )
}
